import { render } from "./LivreView.vue?vue&type=template&id=a8662eb0&scoped=true"
import script from "./LivreView.vue?vue&type=script&lang=js"
export * from "./LivreView.vue?vue&type=script&lang=js"

import "./LivreView.vue?vue&type=style&index=0&id=a8662eb0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8662eb0"]])

export default __exports__